import { RecurringCalendarEvent } from '../types/models';
import {
  fetchKoreanHolidaysFromSupabase,
  fetchFoundationAnniversaryFromSupabase,
} from '../services/subscribedCalendarEventsService';

/**
 * 구독 캘린더 클릭 동작 타입
 */
export enum CalendarClickAction {
  NONE = 'none',           // 클릭해도 아무 동작 없음
  BOOKING = 'booking',     // 예약 모달 표시 (미래 사용 가능성)
  CUSTOM_MODAL = 'custom_modal',  // 커스텀 모달 표시
}

/**
 * 구독 캘린더 설정 인터페이스
 * - SRP: 각 캘린더는 자신의 데이터 fetcher와 스타일을 가짐
 * - OCP: 새 캘린더 추가 시 이 파일에 객체만 추가하면 됨
 */
export interface SubscribedCalendarConfig {
  id: string;                                          // 고유 식별자
  name: string;                                        // 표시 이름
  color: string;                                       // 이벤트 배경색
  borderColor?: string;                                // 이벤트 테두리색 (선택, 기본값은 color와 동일)
  textColor?: string;                                  // 이벤트 텍스트색 (선택, 기본값은 #ffffff)
  prefix?: string;                                     // 제목 앞에 붙일 접두사 (선택)
  fetchData: () => Promise<RecurringCalendarEvent[]>;  // 데이터 가져오기 함수
  enabled: boolean;                                    // 기본 활성화 여부
  clickAction?: CalendarClickAction;                   // 클릭 동작 타입 (선택, 기본값: NONE)
  modalComponent?: React.ComponentType<any>;           // 커스텀 모달 컴포넌트 (clickAction이 CUSTOM_MODAL일 때 사용)
  onCustomClick?: (eventData: any) => void;            // 커스텀 클릭 핸들러 (추가 확장성)
}

/**
 * 구독 캘린더 설정 목록
 * - 새 캘린더 추가 시 여기에 객체만 추가
 * - 순서는 Sidebar에서 표시되는 순서
 */
export const SUBSCRIBED_CALENDARS: SubscribedCalendarConfig[] = [
  {
    id: 'korean-holidays',
    name: '대한민국의 공휴일',
    color: '#DC143C',
    prefix: '', //원래 '🤍 '였는데 오바하는 것 같아서 삭제
    fetchData: fetchKoreanHolidaysFromSupabase,
    enabled: false,
    clickAction: CalendarClickAction.NONE,
  },
  {
    id: 'foundation-anniversary',
    name: '창립기념일',
    color: '#008080',
    prefix: '', //원래 '🌤️ '였는데 오바하는 것 같아서 삭제
    fetchData: fetchFoundationAnniversaryFromSupabase,
    enabled: false,
    clickAction: CalendarClickAction.NONE,
  },
];

/**
 * ID로 캘린더 설정 찾기
 */
export const getCalendarConfigById = (id: string): SubscribedCalendarConfig | undefined => {
  return SUBSCRIBED_CALENDARS.find(cal => cal.id === id);
};

/**
 * 이름으로 캘린더 설정 찾기
 */
export const getCalendarConfigByName = (name: string): SubscribedCalendarConfig | undefined => {
  return SUBSCRIBED_CALENDARS.find(cal => cal.name === name);
};
